import { render, staticRenderFns } from "./AdminFinalExamSettingsExamCriteriaView.vue?vue&type=template&id=e3c10d80"
import script from "./AdminFinalExamSettingsExamCriteriaView.vue?vue&type=script&lang=js"
export * from "./AdminFinalExamSettingsExamCriteriaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports